import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import Parse from 'parse';

import './App.css';

import { Login, Register } from './business';
import { RegisterCode } from './code';

class App extends Component {
  constructor(props) {
    super(props);

    // Configure Parse
    Parse.initialize('FAFC2A36-35EA-4BB3-B961-4F51E72F6099');
    Parse.serverURL = 'https://best-of-guide.herokuapp.com/parse';
  }

  state = {
    store: { valid: true },
  };

  render() {
    if (this.state.store === null) {
      return <div>Booting...</div>;
    }

    return (
      <BrowserRouter>
        <div>
          <Route exact path="/" component={Login} />
          <Route path="/business/register" component={Register} />
          <Route path="/code/register" component={RegisterCode} />
        </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js